<div class="login-container">
  <!-- SSO Section for KKU/KMITL -->
  <ng-container *ngIf="siteName == 'KKU' || siteName == 'KMITL'">
    <div class="text-center sso-section">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3 fw-bold">{{'Single Sign On'|translate}}</p>
    </div>
  </ng-container>

  <!-- SSO Section for YRU -->
  <div class="text-center sso-section" *ngIf="siteName == 'YRU'">
    <h4 class="login-title mb-4">{{'login'|translate}}</h4>
    <a class="btn btn-sso w-100" type="button" (click)="clickSsoYru()">
      <img src="assets/images/library-icon/logo-yru-passport.png" alt="YRU Passport" style="max-width: 180px;">
    </a>
    <div class="divider">{{'OR'|translate}}</div>
  </div>

  <!-- Main Login Form -->
  <main *ngIf="siteName != 'KKU' && siteName != 'KMITL'">
    <form [formGroup]="loginForm">
      <div class="logo-section" [routerLink]="['/home']">
        <ng-container *ngIf="siteName != 'YRU'">
          <img src="{{ logo }}" onError="this.src='assets/images/logo_default.png'" alt="Logo" class="logo-img">
          <h4 class="login-title">{{'login'|translate}}</h4>
        </ng-container>
        <h4 class="login-title text-secondary" *ngIf="siteName == 'YRU'">บุคคลภายนอก</h4>
      </div>

      <div class="form-floating mb-3">
        <input type="text" class="form-control" formControlName="username" id="floatingInput"
          placeholder="{{userLogin|translate}}">
        <label for="floatingInput"><i class="fa fa-user me-2"></i>{{userLogin|translate}}</label>
      </div>

      <div class="form-floating mb-3 position-relative">
        <input [type]="passwordFieldType" autocomplete="off" class="form-control" id="floatingPassword"
          placeholder="Password" formControlName="password">
        <label for="floatingPassword"><i class="fa fa-lock me-2"></i>{{'Password'|translate}}</label>
        <button type="button" class="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
          (click)="togglePasswordVisibility()">
          <i [ngClass]="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'" class="text-muted"></i>
        </button>
      </div>

      <!-- MOJ Special Notice -->
      <div *ngIf="sitename == 'MOJ'" class="alert alert-warning small py-2">
        <p class="mb-1">การใช้งานระบบห้องสมุดจะต้องมีการยืนยัน PDPA โดยผู้ใช้งานสามารถดาวน์โหลดเอกสารได้จาก
          <a [href]="pdpaUrl" [hidden]="pdpaUrl == null || pdpaUrl  == ''" class="alert-link text-decoration-underline"
            role="button" target="_blank">เอกสารยินยอม</a>
        </p>
        <p class="mb-0">ส่งไปที่ <span class="fw-bold">{{EmailContact}}</span></p>
      </div>

      <div class="text-center mt-4">
        <button class="btn btn-login btn-lg w-100 mb-3" (click)="clickLogin()" [disabled]="!loginForm.valid"
          *ngIf="!Onlogin">
          {{'login'|translate}}
        </button>

        <button class="btn btn-login btn-lg w-100 mb-3" type="button" disabled *ngIf="Onlogin">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{'Processing...'|translate}}
        </button>

        <a class="help-link d-block" (click)="help()">
          <i class="fa fa-question-circle me-1"></i>{{'Help'|translate}}
        </a>
      </div>
    </form>
  </main>
</div>